export const DEFAULT_ICE_SERVERS = [
    {
        urls: ["stun:148.251.144.85:443"],
    },
    {
        urls: ["turn:148.251.144.85:443?transport=tcp"],
        username: "username",
        credential: "password",
    },
];
export var AuviousRtcState;
(function (AuviousRtcState) {
    AuviousRtcState["UNREGISTERED"] = "UNREGISTERED";
    AuviousRtcState["REGISTERING"] = "REGISTERING";
    AuviousRtcState["REGISTERED"] = "REGISTERED";
})(AuviousRtcState || (AuviousRtcState = {}));
//# sourceMappingURL=model.js.map